import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

/** Up to two initials from a display name; a trailing "(…)" is ignored. */
function initials(name: string): string {
  const parts = name.replace(/\(.*\)/, '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return (parts[0][0] + (parts[1]?.[0] ?? '')).toUpperCase();
}

/** One person's avatar: their photo, or initials while it loads / when there is none. */
export function PersonAvatar({
  name,
  photo,
  size = 'sm',
  className,
}: {
  name: string;
  photo?: string | null;
  size?: 'sm' | 'default' | 'lg';
  className?: string;
}) {
  return (
    <Avatar size={size} title={name} className={className}>
      {photo ? <AvatarImage src={photo} alt={name} /> : null}
      <AvatarFallback>{initials(name)}</AvatarFallback>
    </Avatar>
  );
}
